import React, { useState } from "react";

const FAQ = ({ onBack }) => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const faqs = [
    {
      question: "What price will I be charged on renewal",
      answer: "The price you will be charged when your subscription automatically renews depends on how you subscribed.\n\nIf you subscribed via our site directly (and not through the app), please send a quick note to help@famjam.com and be sure to include the email address on your account. We will get back to you quickly with more information on your renewal price."
    },
    {
      question: "How can I upgrade my subscription",
      answer: "To upgrade your subscription, go to the 'Manage Subscription' section in your settings and choose the desired plan."
    },
    {
      question: "I purchased my subscription via the Apple App Store and want a refund. What can I do?",
      answer: "For refunds on subscriptions purchased through the Apple App Store, please contact Apple Support directly."
    }
  ];

  const handleQuestionClick = (faq) => {
    setSelectedQuestion(faq);
    setCurrentView('answer');
  };

  const Header = ({ onBackClick }) => (
    <div className="w-full flex items-center " style={{
      background: "linear-gradient(to bottom, rgba(225, 225, 225, 1) 0%, rgba(225, 225, 225, 0) 100%)",
      padding: "35px 21px 26px"
    }}>
      <button
        onClick={onBackClick}
        className=" absolute top-[34px] bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-gray-400"
          fill="none"
          viewBox="0 0 26 26"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <h1 className="text-[20px] leading-[20px] font-normal font-young-serif text-center mx-auto">
        FAQs
      </h1>
    </div>
  );

  if (currentView === 'answer' && selectedQuestion) {
    return (
      <div className="min-h-screen bg-white">
        <Header onBackClick={() => setCurrentView('list')} />
        <div className="px-6">
        <div className="mx-1 border-t border-[#EEEEEE]" />
          <h2 className="text-[20px] font-medium leading-[25px] font-young-serif text-[#1E0A1E] mt-4 mb-6">
            {selectedQuestion.question}
          </h2>
          <div className="font-space-grotesk text-[16px] leading-[24px] text-[#1E0A1E]">
            {selectedQuestion.answer.split('\n\n').map((paragraph, index) => (
              <p key={index} className="mb-4">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header onBackClick={onBack} />
      <div className="rounded-xl text-[16px] font-young-serif p-6 pt-0">
        <div className="mx-1 border-t border-[#EEEEEE]" />
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-[#EEEEEE]">
            <button
              onClick={() => handleQuestionClick(faq)}
              className="w-full flex justify-between items-center py-4 text-gray-800 hover:bg-gray-50"
            >
              <span className="font-space-grotesk text-left font-normal text-[#1E0A1E] text-[14px]">
                {faq.question}
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="h-6 w-6 text-[#0F172A] flex-shrink-0"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;